/*
 *
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
Entry.BlockToPyParser = /*#__PURE__*/function () {
  function _class() {
    (0, _classCallCheck2["default"])(this, _class);
    this._type = 'BlockToPyParser';
    this._funcParamMap = new Entry.Map();
    this.funcDefMap = {};
    this.globalCommentList = [];
    this._variableDeclaration = null;
    this._listDeclaration = null;
    this._forIdCharIndex = 0;
  }
  return (0, _createClass2["default"])(_class, [{
    key: "Code",
    value: function Code(code, parseMode) {
      this._parseMode = parseMode;
      if (!code) {
        return;
      }
      if (code instanceof Entry.Thread) {
        return this.Thread(code);
      }
      if (code instanceof Entry.Block) {
        return this.Block(code);
      }
      var resultTextCode = [];
      var threads = code.getThreads();
      for (var i = 0; i < threads.length; i++) {
        this._forIdCharIndex = 0;
        var thread = threads[i];
        if (thread) {
          resultTextCode.push(this.Thread(thread));
        }
      }
      return resultTextCode.join('\n').trim();
    }
  }, {
    key: "Thread",
    value: function Thread(thread) {
      var _this = this;
      if (thread instanceof Entry.Block) {
        return this.Block(thread);
      }
      var blocks = thread.getBlocks();
      if (blocks.length === 0) {
        return '';
      }
      if (blocks[0] instanceof Entry.Comment) {
        this.Comment(blocks[0]);
      } else if (this._parseMode === Entry.Parser.PARSE_SYNTAX) {
        return blocks.map(function (block) {
          return "".concat(_this.Block(block), "\n");
        }).trim();
      } else if (this._parseMode === Entry.Parser.PARSE_GENERAL) {
        var rootResult = '';
        var contentResult = '';
        blocks.forEach(function (block, index) {
          try {
            if (index === 0 && Entry.TextCodingUtil.isEventBlock(block)) {
              rootResult = "".concat(_this.Block(block), "\n");
            } else {
              contentResult += "".concat(_this.Block(block), "\n");
            }
          } catch (e) {
            Entry.toast.alert(Lang.TextCoding.title_converting, Lang.TextCoding.alert_legacy_no_support);
          }
        });
        if (rootResult !== '') {
          contentResult = Entry.TextCodingUtil.indent(contentResult);
        }
        return "".concat((rootResult + contentResult).trim(), "\n");
      }
    }
  }, {
    key: "Block",
    value: function Block(block) {
      var _this2 = this;
      if (!block || !(block instanceof Entry.Block)) {
        return '';
      }
      !block._schema && block.loadSchema();
      var results = [];
      var syntaxObj = this.searchSyntax(block);
      var syntax;
      if (syntaxObj) {
        syntax = syntaxObj.syntax;
      }

      // User Function
      if (this.isFunc(block)) {
        if (!this.funcDefMap[block.data.type]) {
          this._rootFuncId = block.data.type;
          this.funcDefMap[block.data.type] = this.makeFuncDef(block, this._hasRootFunc);
          this._hasRootFunc = false;
        }
        if (this.isRegisteredFunc(block)) {
          syntax = this.makeFuncSyntax(block);
        }
        if (this._parseMode === Entry.Parser.PARSE_SYNTAX) {
          return syntax;
        }
      } else if (this.isFuncStmtParam(block)) {
        var type = block.data.type;
        results.push(this._funcParamMap.get(type) || type);
      }
      if (!syntax && !this.isFuncStmtParam(block)) {
        var error = new Error();
        error.block = block;
        throw error;
      }
      var _blockTokens = syntax.split(/[\r\n]/);
      var _blockParamRegex = /%\d/gim;
      var _blockStatementRegex = /\$\d/gim;
      var isFirstCommentToken = true;
      _blockTokens.forEach(function (token) {
        var tokenProcessed = token;
        // 이재원 #7994 관련하여 만약 token (text input) 에 시작하는 템플릿이 괄호라면,
        // 그리고 하나의 Param만 가지고 있는 경우를 regex check 후에 slice해서 사용.
        if (_blockTokens.length == 1 && /^\(%[\d ]+\)/gim.test(tokenProcessed)) {
          tokenProcessed = tokenProcessed.slice(1, -1);
        }
        var paramsTemplate = tokenProcessed.match(_blockParamRegex);
        var statements = tokenProcessed.match(_blockStatementRegex);
        var resultTextCode = '';

        // %1 과 같은 템플릿 값이 있는 경우
        if (paramsTemplate) {
          var paramsValue = [];
          paramsTemplate.forEach(function (template) {
            var _template$split = template.split('%'),
              _template$split2 = (0, _slicedToArray2["default"])(_template$split, 2),
              index = _template$split2[1];
            if (index) {
              paramsValue[index] = _this2._getParamsValue(index, block);
            }
          });
          resultTextCode += tokenProcessed.replace(/%(\d)/gim, function (_, groupMatch) {
            return paramsValue[groupMatch];
          });
        }

        // $1 과 같이 statement 를 포함하는 경우
        if (statements) {
          statements.forEach(function (value) {
            var _value$split = value.split('$'),
              _value$split2 = (0, _slicedToArray2["default"])(_value$split, 2),
              index = _value$split2[1];
            var statementTextCodes = [];
            var thread = block.statements[index - 1];
            thread.getBlocks().forEach(function (block) {
              if (_this2.getFuncInfo(block)) {
                statementTextCodes.push(_this2.makeFuncDef(block, true));
              } else {
                statementTextCodes.push(_this2.Block(block));
              }
            });
            resultTextCode += Entry.TextCodingUtil.indent(statementTextCodes.join('\n').concat('\n'));
          });
        }

        // 일반 블록 처리
        if (!statements && !paramsTemplate) {
          resultTextCode += tokenProcessed;
        }

        // 특수 블록 처리
        // TODO 이와 같은 처리는 블록에 정보가 있고, 정보에 따라 처리해야 한다.
        if (syntaxObj) {
          switch (syntaxObj.key) {
            case 'repeat_while_true':
              resultTextCode = Entry.TextCodingUtil.assembleRepeatWhileTrueBlock(block, resultTextCode);
              break;
            case 'repeat_basic':
              {
                var forStmtTokens = resultTextCode.split(' ');
                if ((0, _includes2["default"])(forStmtTokens, 'for', 'i', 'in')) {
                  forStmtTokens[1] = Entry.TextCodingUtil.generateForStmtIndex(_this2._forIdCharIndex++);
                  resultTextCode = forStmtTokens.join(' ');
                }
                break;
              }
            case 'substring':
              {
                // "안녕 엔트리"[1:5] -> "안녕 엔트리", [1:5]
                var tokens = resultTextCode.split(/(?=\[)/);
                if (tokens.length === 2 && Entry.Utils.isNumber(tokens[0])) {
                  tokens[0] = "\"".concat(tokens[0], "\"");
                }
                resultTextCode = tokens.join('');
                break;
              }
          }
        }

        // 코멘트 처리
        var commentValue = block.getCommentValue();
        if (isFirstCommentToken && !statements && commentValue !== undefined) {
          // '' 도 표기한다.
          resultTextCode += " # ".concat(commentValue);
          isFirstCommentToken = !isFirstCommentToken;
        }
        results.push(resultTextCode);
      });
      return results.join('\n');
    }
  }, {
    key: "Comment",
    value: function Comment(comment) {
      this.globalCommentList.push("# ".concat(comment.value));
    }

    /**
     * 해당 block 의 template parameter 의 실제 값을 가져온다.
     * @param templateIndex index 번호 (%2 라면 2)
     * @param block 추출할 블록
     * @returns {string} 블록의 결과값
     * @private
     */
  }, {
    key: "_getParamsValue",
    value: function _getParamsValue(templateIndex, block) {
      var index = Number(templateIndex) - 1;
      var schemaParams = block._schema.params;
      var dataParams = block.data.params;
      var result = '';
      var syntaxObj = this.searchSyntax(block);
      var textParams = syntaxObj.textParams && syntaxObj.textParams;
      if (schemaParams[index]) {
        switch (schemaParams[index].type) {
          case 'Indicator':
            {
              break;
            }
          case 'Block':
            {
              var param = this.Block(dataParams[index]).trim();
              var funcParam = this._funcParamMap.get(param);
              var textParam = textParams && textParams[index];
              if (funcParam) {
                param = funcParam;
              } else {
                var funcParamTokens = param.split('_');
                var prefix = funcParamTokens[0];
                if (funcParamTokens.length === 2) {
                  if (prefix === 'stringParam') {
                    param = 'string_param';
                  } else if (prefix === 'booleanParam') {
                    param = 'boolean_param';
                  }
                }
              }
              if (textParam && textParam.paramType === 'index') {
                if (Entry.Utils.isNumber(param)) {
                  param = param - 1;
                } else {
                  var tokens = param.split('+');
                  if (tokens[tokens.length - 1] === ' 1)') {
                    delete tokens[tokens.length - 1];
                    param = tokens.join('+');
                    param = param.substring(1, param.length - 2);
                  } else {
                    param += ' - 1';
                  }
                }
              }
              if (textParam && textParam.paramType === 'integer') {
                if (Entry.Utils.isNumber(param) && Entry.isFloat(param)) {
                  result = result.replace('randint', 'uniform');
                }
              }
              result += param;
              break;
            }
          default:
            {
              var _textParam = textParams && textParams[index];
              var _param;
              if (_textParam && _textParam.type) {
                _param = this["Field".concat(_textParam.type)](dataParams[index], _textParam);
              } else {
                _param = this["Field".concat(schemaParams[index].type)](dataParams[index], _textParam);
              }
              var isTypeNumber = Entry.Utils.isNumber(_param);

              // 필드 블록이 아닌 블록에 내재된 파라미터 처리
              if (!Entry.Utils.isNumber(_param) && (block.type === 'when_some_key_pressed' || block.type === 'is_press_some_key')) {
                if (!Entry.KeyboardCode.map[typeof _param === 'string' ? _param.toLowerCase() : _param]) {
                  Entry.toast.alert(Lang.Msgs.warn, Lang.Msgs.parameter_can_not_space);
                  throw Error('');
                }
                result += "\"".concat(_param, "\"");
              } else if (!isTypeNumber && Entry.Utils.isNumber(_param) && (block.type === 'number' || block.type === 'string')) {
                result += "\"".concat(_param, "\"");
              } else {
                result += _param;
              }
              break;
            }
        }
      }
      return result;
    }
  }, {
    key: "searchSyntax",
    value: function searchSyntax(datum) {
      var schema;
      var appliedParams;
      if (datum instanceof Entry.BlockView) {
        schema = datum.block._schema;
        appliedParams = datum.block.data.params;
      } else if (datum instanceof Entry.Block) {
        schema = datum._schema;
        appliedParams = datum.params;
      } else {
        schema = datum;
      }
      if (schema && schema.syntax && schema.syntax.py && schema.syntax.py.length > 0) {
        var syntaxes = schema.syntax.py.concat();
        while (syntaxes.length) {
          var isFail = false;
          var syntax = syntaxes.shift();
          if (typeof syntax === 'string') {
            return {
              syntax: syntax,
              template: syntax
            };
          }
          if (syntax.params) {
            for (var i = 0; i < syntax.params.length; i++) {
              if (syntax.params[i] && syntax.params[i] !== appliedParams[i]) {
                isFail = true;
                break;
              }
            }
          }
          if (!syntax.template) {
            syntax.template = syntax.syntax;
          }
          if (isFail) {
            continue;
          }
          return syntax;
        }
      }
      return null;
    }
  }, {
    key: "FieldAngle",
    value: function FieldAngle(dataParam, textParam) {
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldColor",
    value: function FieldColor(dataParam, textParam) {
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(null, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldDropdown",
    value: function FieldDropdown(dataParam, textParam) {
      if ((0, _typeof2["default"])(dataParam) === 'object') {
        return 'None'.replace(/\"/gm, '');
      }
      if (textParam && textParam.converter && textParam.options) {
        var options = textParam.options;
        for (var i in options) {
          var key = options[i][0];
          var value = options[i][1];
          if (dataParam == value) {
            return dataParam = textParam.converter(key, value);
          }
        }
        dataParam = textParam.converter(dataParam, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldDropdownDynamic",
    value: function FieldDropdownDynamic(dataParam, textParam) {
      if ((0, _typeof2["default"])(dataParam) === 'object') {
        return 'None'.replace(/\"/gm, '');
      }
      if (textParam && textParam.converter && textParam.options) {
        var options = textParam.options;
        for (var i in options) {
          var key = options[i][0];
          var _value = options[i][1];
          if (dataParam == _value) {
            var name = Entry.TextCodingUtil.dropdownDynamicIdToNameConvertor(_value, textParam.menuName);
            if (name) {
              key = name;
            }
            return dataParam = textParam.converter(key, _value);
          }
        }
        var value = Entry.TextCodingUtil.dropdownDynamicIdToNameConvertor(dataParam, textParam.menuName);
        if (value) {
          dataParam = textParam.converter(value, value);
        } else {
          dataParam = textParam.converter(dataParam, dataParam);
        }
        var reg = /None/;
        if (reg.test(dataParam)) {
          dataParam = dataParam.replace(/\"/gm, '');
        }
      }
      return dataParam;
    }
  }, {
    key: "FieldImage",
    value: function FieldImage(dataParam, textParam) {
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(null, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldIndicator",
    value: function FieldIndicator(dataParam, textParam) {
      return dataParam;
    }
  }, {
    key: "FieldKeyboard",
    value: function FieldKeyboard(dataParam, textParam) {
      var reg = /None/;
      if (reg.test(dataParam)) {
        return dataParam.replace(/\"/gm, '');
      }
      var map = Entry.KeyboardCode.map;
      for (var key in map) {
        var value = map[key];
        if (value == dataParam) {
          dataParam = key;
          break;
        }
      }
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(dataParam, null);
      }
      dataParam = dataParam.toLowerCase();
      return dataParam;
    }
  }, {
    key: "FieldOutput",
    value: function FieldOutput(dataParam, textParam) {
      return dataParam;
    }
  }, {
    key: "FieldText",
    value: function FieldText(dataParam, textParam) {
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(null, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldTextInput",
    value: function FieldTextInput(dataParam, textParam) {
      if (typeof dataParam !== 'number') {
        dataParam = dataParam.replace('\t', '    ');
        var spaces = dataParam.split(/ /);
        if (dataParam.length == spaces.length - 1) {
          dataParam = '"()"'.replace('()', dataParam);
        }
      }
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(null, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "FieldNumber",
    value: function FieldNumber(dataParam, textParam) {
      if (textParam && textParam.converter) {
        dataParam = textParam.converter(null, dataParam);
      }
      return dataParam;
    }
  }, {
    key: "isFunc",
    value: function isFunc(block) {
      if (!block || !block.data || !block.data.type) {
        return false;
      }
      var tokens = block.data.type.split('_');
      var prefix = tokens[0];
      return prefix === 'func';
    }

    /**
     * 워크스페이스에 실제로 등록되어있는 함수인지 확인한다.
     * @param block
     * @returns {boolean}
     */
  }, {
    key: "isRegisteredFunc",
    value: function isRegisteredFunc(block) {
      var tokens = block.data.type.split('_');
      var funcId = tokens[1];
      return !!Entry.variableContainer.functions_[funcId];
    }
  }, {
    key: "isFuncStmtParam",
    value: function isFuncStmtParam(block) {
      if (!block || !block.data || !block.data.type) {
        return false;
      }
      var blockType = block.data.type;
      var tokens = blockType.split('_');
      var prefix = tokens[0];
      return prefix === 'stringParam' || prefix === 'booleanParam';
    }

    /**
     * functionTemplate 에서 파이선에서 표기될 함수를 만들어낸다.
     * ex) 함수 %1 %2 %3 + %3 이 Indicator 인 경우 => 함수(%1, %2)
     * @param funcBlock{Block} 함수 블록
     * @return {string} 파이선 함수 호출 syntax
     */
  }, {
    key: "makeFuncSyntax",
    value: function makeFuncSyntax(funcBlock) {
      var schemaTemplate = '';
      if (funcBlock) {
        if (funcBlock._schema) {
          if (funcBlock._schema.template) {
            schemaTemplate = funcBlock._schema.template.trim();
          }
        } else if (this._hasRootFunc) {
          var rootFunc = Entry.block[this._rootFuncId];
          schemaTemplate = rootFunc.block.template;
        }
      }
      var templateParams = schemaTemplate.trim().match(/%\d/gim);
      templateParams.pop(); // pop() 이유는 맨 마지막 템플릿은 Indicator 로 판단할 것이기 때문이다.

      return Entry.TextCodingUtil.getFunctionNameFromTemplate(schemaTemplate).trim().concat("(".concat(templateParams.join(','), ")"));
    }
  }, {
    key: "makeFuncDef",
    value: function makeFuncDef(funcBlock, isExpression) {
      if (!this.isRegisteredFunc(funcBlock)) {
        return;
      }
      var result = '';
      var func = this.getFuncInfo(funcBlock);
      if (func) {
        result += func.name;
      } else {
        return;
      }
      var paramResult = '';
      if (func.params && func.params.length !== 0) {
        paramResult = func.params.join(', ').trim();
      }
      result = result.concat('(').concat(paramResult).concat(')');
      if (isExpression) {
        // 선언된 함수 사용하는 블록의 경우
        var expBlockComment = funcBlock.getCommentValue();
        if (expBlockComment || expBlockComment === '') {
          result += " # ".concat(expBlockComment);
        }
        return result;
      } else {
        // 함수 선언 중인 경우
        this._hasRootFunc = true;
        result = "def ".concat(result);
        result = result.concat(':');
        if (func.comment || func.comment === '') {
          result += " # ".concat(func.comment);
        }
        result += '\n';
        if (func.statements && func.statements.length) {
          var stmtResult = '';
          for (var s in func.statements) {
            var block = func.statements[s];
            if (this.getFuncInfo(block)) {
              stmtResult += this.makeFuncDef(block, true).concat('\n');
            } else {
              stmtResult += this.Block(block).concat('\n');
            }
          }
          result += Entry.TextCodingUtil.indent(stmtResult).concat('\n');
        }
        return result.trim();
      }
    }
  }, {
    key: "getFuncInfo",
    value: function getFuncInfo(funcBlock) {
      var result = {};
      var funcId = funcBlock.getFuncId();
      var func = funcId && Entry.variableContainer.getFunction(funcId);
      if (!func) {
        return null;
      }
      var funcName = Entry.TextCodingUtil.getFunctionNameFromTemplate(func.block.template);
      Entry.TextCodingUtil.initQueue();
      var funcContents = func.content.getEventMap('funcDef')[0].getThread().getBlocks();
      var statements = func.content.getEventMap('funcDef')[0].getStatements().getBlocks();
      statements.forEach(function (value) {
        return funcContents.push(value);
      });
      var defBlock = funcContents.shift();
      var funcComment = defBlock.getCommentValue();
      Entry.TextCodingUtil.gatherFuncDefParam(defBlock.getParam(0));
      var that = this;
      var funcParams = [];
      if (!this._hasRootFunc) {
        var funcDefParams = [];
        var param;
        while (param = Entry.TextCodingUtil._funcParamQ.dequeue()) {
          funcDefParams.push(param);
        }
        funcDefParams.forEach(function (value, index) {
          if (/(string|boolean)Param/.test(value)) {
            index += 1;
            var name = "param".concat(index);
            funcParams.push(name);
            that._funcParamMap.put(value, name);
          }
        });
      } else {
        funcBlock.params.filter(function (p) {
          return p instanceof Entry.Block;
        }).forEach(function (p) {
          var paramText = that.Block(p);
          if (!paramText) {
            return;
          }
          paramText = that._funcParamMap.get(paramText) || paramText;
          funcParams.push(paramText);
        });
      }
      Entry.TextCodingUtil.clearQueue();
      if (funcName) {
        result.name = funcName;
      }
      if (funcComment || funcComment === '') {
        result.comment = funcComment;
      }
      if (funcParams.length !== 0) {
        result.params = funcParams;
      }
      if (funcContents.length !== 0) {
        result.statements = funcContents;
      }
      return result;
    }
  }]);
}();